/** @jsxRuntime classic */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxfrag */

import { useEffect } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import { N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { type SurfaceModule } from '@atlassian/surface-sdk';

import { type Actions } from '../../../index';

import { type AppRecommendationsSectionHeaderProps } from './types';

const HeadingStyles = css({
	fontWeight: 700,
	color: token('color.text.subtlest', N200),
	fontSize: '11px',
	marginBottom: token('space.050', '4px'),
	textTransform: 'uppercase',
	marginTop: token('space.0', '0px'),
	marginLeft: token('space.100', '8px'),
});

export const AppRecommendationsSectionHeader: SurfaceModule<
	AppRecommendationsSectionHeaderProps,
	AppRecommendationsSectionHeaderProps,
	Actions
> = ({ title, noAppsTitle = 'Discover', headingLevel, actionBus, mutate }) => {
	const HeadingAs = headingLevel;

	useEffect(() => {
		const unsubscribe = actionBus?.on('USE_EMPTY_APPS_TITLE', () => {
			mutate((currentProps) => ({ ...currentProps, title: noAppsTitle }));
		});

		return unsubscribe;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [actionBus]);

	return (
		<HeadingAs
			data-testid={'discovery-sdk-component--app-recommendation-section-header'}
			css={HeadingStyles}
		>
			{title}
		</HeadingAs>
	);
};

AppRecommendationsSectionHeader.propTypes = {
	title: PropTypes.string.isRequired,
	noAppsTitle: PropTypes.string,
	headingLevel: PropTypes.oneOf<AppRecommendationsSectionHeaderProps['headingLevel']>([
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
	]).isRequired,
};
